import { useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useApi } from "../useApi";
import { isErr } from "../../Utils/Result";
import { eventBus } from "../../EventBus";
import { Notification } from "../../../Components/Notifications";

/**
 * Sends the user to Stripe to buy DD credits on top of the plan; how many is
 * chosen there, and Stripe sends them back to the cases.
 * @returns buyCredits: opens the checkout, once however many clicks.
 */
export const useBuyCredits = () => {
  const { t } = useTranslation();
  const { getCreditsCheckoutEndpoint } = useApi();
  const isRedirecting = useRef(false);

  const buyCredits = useCallback(async () => {
    if (isRedirecting.current) {
      return;
    }
    isRedirecting.current = true;
    const result = await getCreditsCheckoutEndpoint();
    if (isErr(result)) {
      eventBus.emit("NOTIFICATION", Notification.buildNotification("error", t("dueDiligencePlans.buyCredits.checkoutFailed")));
      isRedirecting.current = false;
      return;
    }
    window.location.href = result.value.url;
  }, [getCreditsCheckoutEndpoint, t]);

  return { buyCredits };
};
